import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import ListItemText from '@material-ui/core/ListItemText/ListItemText';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import LabelImportantIcon from '@material-ui/icons/LabelImportant';

function ModoListagemObservacoes(props) {
  const {
    filiado,
    visualizarObservacao
  } = props;

  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        md={12}
        xs={12}
      >
        <List >
          {
            filiado && filiado.observacoes && filiado.observacoes.map((observacao, index) => {
              return (
                <div>
                  <ListItem
                    alignItems="flex-start"
                    key={index}
                    button
                    onClick={e => visualizarObservacao(e, index)}
                  >
                    <ListItemAvatar>
                      <Avatar>
                        <LabelImportantIcon />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={observacao.titulo}
                      secondary={
                        <React.Fragment>
                          <Typography
                            component="span"
                            variant="body2"
                            color="textSecondary"
                            style={{
                              wordWrap:'break-word'
                            }}
                          >
                            {observacao.descricao}
                          </Typography>
                        </React.Fragment>
                      }
                    />
                  </ListItem>
                  <Divider variant="inset" component="li" />
                </div>
              );
            })
          }
        </List>
      </Grid>
    </Grid>
  );
}

ModoListagemObservacoes.propTypes = {
  className: PropTypes.string,
};

export default ModoListagemObservacoes;


